import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0fe8d244 = () => interopDefault(import('../pages/achievements/index.vue' /* webpackChunkName: "pages/achievements/index" */))
const _6f61a46e = () => interopDefault(import('../pages/appointments/index.vue' /* webpackChunkName: "pages/appointments/index" */))
const _f641fad6 = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _5fc17e32 = () => interopDefault(import('../pages/clinics/index.vue' /* webpackChunkName: "pages/clinics/index" */))
const _636390e4 = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _c843bc10 = () => interopDefault(import('../pages/medcard/index.vue' /* webpackChunkName: "pages/medcard/index" */))
const _072222ce = () => interopDefault(import('../pages/path-without-handling/index.vue' /* webpackChunkName: "pages/path-without-handling/index" */))
const _5f1df485 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _2cc3aa2f = () => interopDefault(import('../pages/rates/index.vue' /* webpackChunkName: "pages/rates/index" */))
const _5dff3693 = () => interopDefault(import('../pages/rules/index.vue' /* webpackChunkName: "pages/rules/index" */))
const _0cb3f1ad = () => interopDefault(import('../pages/unconfirmed-documents/index.vue' /* webpackChunkName: "pages/unconfirmed-documents/index" */))
const _3f97e46e = () => interopDefault(import('../pages/appointments/confirmation.vue' /* webpackChunkName: "pages/appointments/confirmation" */))
const _bfb605ae = () => interopDefault(import('../pages/appointments/past/index.vue' /* webpackChunkName: "pages/appointments/past/index" */))
const _cfef4da2 = () => interopDefault(import('../pages/appointments/repeat.vue' /* webpackChunkName: "pages/appointments/repeat" */))
const _74a408da = () => interopDefault(import('../pages/dental/articles.vue' /* webpackChunkName: "pages/dental/articles" */))
const _1ee873f8 = () => interopDefault(import('../pages/dental/articles/adentia.vue' /* webpackChunkName: "pages/dental/articles/adentia" */))
const _6199c465 = () => interopDefault(import('../pages/dental/articles/anomalies.vue' /* webpackChunkName: "pages/dental/articles/anomalies" */))
const _25d82814 = () => interopDefault(import('../pages/dental/articles/calculus.vue' /* webpackChunkName: "pages/dental/articles/calculus" */))
const _368d50a2 = () => interopDefault(import('../pages/dental/articles/caries.vue' /* webpackChunkName: "pages/dental/articles/caries" */))
const _68450e49 = () => interopDefault(import('../pages/dental/articles/gingivitis.vue' /* webpackChunkName: "pages/dental/articles/gingivitis" */))
const _a7e11380 = () => interopDefault(import('../pages/dental/articles/parodontitis.vue' /* webpackChunkName: "pages/dental/articles/parodontitis" */))
const _103a53a6 = () => interopDefault(import('../pages/dental/articles/periodontitis.vue' /* webpackChunkName: "pages/dental/articles/periodontitis" */))
const _2e9a840a = () => interopDefault(import('../pages/dental/articles/pulpitis.vue' /* webpackChunkName: "pages/dental/articles/pulpitis" */))
const _544e09cc = () => interopDefault(import('../pages/favourites/folders/index.vue' /* webpackChunkName: "pages/favourites/folders/index" */))
const _13640deb = () => interopDefault(import('../pages/medcard/folders.vue' /* webpackChunkName: "pages/medcard/folders" */))
const _6db3fa85 = () => interopDefault(import('../pages/medcard/share.vue' /* webpackChunkName: "pages/medcard/share" */))
const _64c088aa = () => interopDefault(import('../pages/medcard/treatment-plan/index.vue' /* webpackChunkName: "pages/medcard/treatment-plan/index" */))
const _75ffff04 = () => interopDefault(import('../pages/profile/family/index.vue' /* webpackChunkName: "pages/profile/family/index" */))
const _240a4d80 = () => interopDefault(import('../pages/profile/settings.vue' /* webpackChunkName: "pages/profile/settings" */))
const _4ec90ee0 = () => interopDefault(import('../pages/wb-id/login.vue' /* webpackChunkName: "pages/wb-id/login" */))
const _9ece95e8 = () => interopDefault(import('../pages/chat/doctor/payment-wait.vue' /* webpackChunkName: "pages/chat/doctor/payment-wait" */))
const _301c8c94 = () => interopDefault(import('../pages/oauth/external/login.vue' /* webpackChunkName: "pages/oauth/external/login" */))
const _071c576a = () => interopDefault(import('../pages/profile/family/merge.vue' /* webpackChunkName: "pages/profile/family/merge" */))
const _1d40766b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _732af905 = () => interopDefault(import('../pages/favourites/folders/_id/index.vue' /* webpackChunkName: "pages/favourites/folders/_id/index" */))
const _9ce5edd4 = () => interopDefault(import('../pages/medcard/treatment-plan/_id/index.vue' /* webpackChunkName: "pages/medcard/treatment-plan/_id/index" */))
const _0b7f5ecc = () => interopDefault(import('../pages/profile/family/_uuid.vue' /* webpackChunkName: "pages/profile/family/_uuid" */))
const _6e3e7c85 = () => interopDefault(import('../pages/analyses/_id/index.vue' /* webpackChunkName: "pages/analyses/_id/index" */))
const _5ad6d859 = () => interopDefault(import('../pages/appointments/_id/index.vue' /* webpackChunkName: "pages/appointments/_id/index" */))
const _5b34fe3a = () => interopDefault(import('../pages/medcard/_id/index.vue' /* webpackChunkName: "pages/medcard/_id/index" */))
const _43541e90 = () => interopDefault(import('../pages/nps/_id/index.vue' /* webpackChunkName: "pages/nps/_id/index" */))
const _3b0fc410 = () => interopDefault(import('../pages/to/_next/index.vue' /* webpackChunkName: "pages/to/_next/index" */))
const _3fb26e18 = () => interopDefault(import('../pages/unconfirmed-documents/_id/index.vue' /* webpackChunkName: "pages/unconfirmed-documents/_id/index" */))
const _5d8269a8 = () => interopDefault(import('../pages/appointments/_id/creation.vue' /* webpackChunkName: "pages/appointments/_id/creation" */))
const _4d8c34ef = () => interopDefault(import('../pages/appointments/_id/pay.vue' /* webpackChunkName: "pages/appointments/_id/pay" */))
const _90d76eb6 = () => interopDefault(import('../pages/appointments/_id/payment-wait.vue' /* webpackChunkName: "pages/appointments/_id/payment-wait" */))
const _768bee51 = () => interopDefault(import('../pages/appointments/_id/prepare/index.vue' /* webpackChunkName: "pages/appointments/_id/prepare/index" */))
const _1b39a2a4 = () => interopDefault(import('../pages/appointments/_id/repeat.vue' /* webpackChunkName: "pages/appointments/_id/repeat" */))
const _ee869cae = () => interopDefault(import('../pages/appointments/_id/telemed.vue' /* webpackChunkName: "pages/appointments/_id/telemed" */))
const _7f364cb4 = () => interopDefault(import('../pages/appointments/_id/transfer.vue' /* webpackChunkName: "pages/appointments/_id/transfer" */))
const _14a905cc = () => interopDefault(import('../pages/appointments/_id/prepare/questions.vue' /* webpackChunkName: "pages/appointments/_id/prepare/questions" */))
const _26ea0b38 = () => interopDefault(import('../pages/rates/_type/_id/index.vue' /* webpackChunkName: "pages/rates/_type/_id/index" */))
const _272540b9 = () => interopDefault(import('../pages/rates/_type/_id/chat/index.vue' /* webpackChunkName: "pages/rates/_type/_id/chat/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievements",
    component: _0fe8d244,
    name: "achievements"
  }, {
    path: "/appointments",
    component: _6f61a46e,
    name: "appointments"
  }, {
    path: "/authorization",
    component: _f641fad6,
    name: "authorization"
  }, {
    path: "/clinics",
    component: _5fc17e32,
    name: "clinics"
  }, {
    path: "/favourites",
    component: _636390e4,
    name: "favourites"
  }, {
    path: "/medcard",
    component: _c843bc10,
    name: "medcard"
  }, {
    path: "/path-without-handling",
    component: _072222ce,
    name: "path-without-handling"
  }, {
    path: "/profile",
    component: _5f1df485,
    name: "profile"
  }, {
    path: "/rates",
    component: _2cc3aa2f,
    name: "rates"
  }, {
    path: "/rules",
    component: _5dff3693,
    name: "rules"
  }, {
    path: "/unconfirmed-documents",
    component: _0cb3f1ad,
    name: "unconfirmed-documents"
  }, {
    path: "/appointments/confirmation",
    component: _3f97e46e,
    name: "appointments-confirmation"
  }, {
    path: "/appointments/past",
    component: _bfb605ae,
    name: "appointments-past"
  }, {
    path: "/appointments/repeat",
    component: _cfef4da2,
    name: "appointments-repeat"
  }, {
    path: "/dental/articles",
    component: _74a408da,
    name: "dental-articles",
    children: [{
      path: "adentia",
      component: _1ee873f8,
      name: "dental-articles-adentia"
    }, {
      path: "anomalies",
      component: _6199c465,
      name: "dental-articles-anomalies"
    }, {
      path: "calculus",
      component: _25d82814,
      name: "dental-articles-calculus"
    }, {
      path: "caries",
      component: _368d50a2,
      name: "dental-articles-caries"
    }, {
      path: "gingivitis",
      component: _68450e49,
      name: "dental-articles-gingivitis"
    }, {
      path: "parodontitis",
      component: _a7e11380,
      name: "dental-articles-parodontitis"
    }, {
      path: "periodontitis",
      component: _103a53a6,
      name: "dental-articles-periodontitis"
    }, {
      path: "pulpitis",
      component: _2e9a840a,
      name: "dental-articles-pulpitis"
    }]
  }, {
    path: "/favourites/folders",
    component: _544e09cc,
    name: "favourites-folders"
  }, {
    path: "/medcard/folders",
    component: _13640deb,
    name: "medcard-folders"
  }, {
    path: "/medcard/share",
    component: _6db3fa85,
    name: "medcard-share"
  }, {
    path: "/medcard/treatment-plan",
    component: _64c088aa,
    name: "medcard-treatment-plan"
  }, {
    path: "/profile/family",
    component: _75ffff04,
    name: "profile-family"
  }, {
    path: "/profile/settings",
    component: _240a4d80,
    name: "profile-settings"
  }, {
    path: "/wb-id/login",
    component: _4ec90ee0,
    name: "wb-id-login"
  }, {
    path: "/chat/doctor/payment-wait",
    component: _9ece95e8,
    name: "chat-doctor-payment-wait"
  }, {
    path: "/oauth/external/login",
    component: _301c8c94,
    name: "oauth-external-login"
  }, {
    path: "/profile/family/merge",
    component: _071c576a,
    name: "profile-family-merge"
  }, {
    path: "/",
    component: _1d40766b,
    name: "index"
  }, {
    path: "/favourites/folders/:id",
    component: _732af905,
    name: "favourites-folders-id"
  }, {
    path: "/medcard/treatment-plan/:id",
    component: _9ce5edd4,
    name: "medcard-treatment-plan-id"
  }, {
    path: "/profile/family/:uuid",
    component: _0b7f5ecc,
    name: "profile-family-uuid"
  }, {
    path: "/analyses/:id",
    component: _6e3e7c85,
    name: "analyses-id"
  }, {
    path: "/appointments/:id",
    component: _5ad6d859,
    name: "appointments-id"
  }, {
    path: "/medcard/:id",
    component: _5b34fe3a,
    name: "medcard-id"
  }, {
    path: "/nps/:id",
    component: _43541e90,
    name: "nps-id"
  }, {
    path: "/to/:next",
    component: _3b0fc410,
    name: "to-next"
  }, {
    path: "/unconfirmed-documents/:id",
    component: _3fb26e18,
    name: "unconfirmed-documents-id"
  }, {
    path: "/appointments/:id/creation",
    component: _5d8269a8,
    name: "appointments-id-creation"
  }, {
    path: "/appointments/:id/pay",
    component: _4d8c34ef,
    name: "appointments-id-pay"
  }, {
    path: "/appointments/:id/payment-wait",
    component: _90d76eb6,
    name: "appointments-id-payment-wait"
  }, {
    path: "/appointments/:id/prepare",
    component: _768bee51,
    name: "appointments-id-prepare"
  }, {
    path: "/appointments/:id/repeat",
    component: _1b39a2a4,
    name: "appointments-id-repeat"
  }, {
    path: "/appointments/:id/telemed",
    component: _ee869cae,
    name: "appointments-id-telemed"
  }, {
    path: "/appointments/:id/transfer",
    component: _7f364cb4,
    name: "appointments-id-transfer"
  }, {
    path: "/appointments/:id/prepare/questions",
    component: _14a905cc,
    name: "appointments-id-prepare-questions"
  }, {
    path: "/rates/:type/:id",
    component: _26ea0b38,
    name: "rates-type-id"
  }, {
    path: "/rates/:type/:id?/chat",
    component: _272540b9,
    name: "rates-type-id-chat"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
